import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Response } from '../../../../shared/models/response.model';
import { Caractéristique } from '../models/caractéristique.model';
import { CaracteristiqueCreateRequest } from '../requests/caractéristique-create-request';
import { CaracteristiqueUpdateRequest } from '../requests/caractéristique-update-request';

@Injectable({
  providedIn: 'root',
})
export class CaractéristiqueService {
  #http = inject(HttpClient);

  readonly BASE_URL = `/caractéristiques`;

  findAll(idReferentiel: string) {
    return this.#http.get<Response<Caractéristique>>(this.BASE_URL, { params: { idReferentiel } });
  }

  create(data: CaracteristiqueCreateRequest) {
    return this.#http.post<void>(this.BASE_URL, data);
  }

  update(idCaracteristique: string, data: CaracteristiqueUpdateRequest) {
    return this.#http.put<void>(this.BASE_URL + `/${idCaracteristique}`, data);
  }

  supprimer(idCaracteristique: string) {
    return this.#http.delete<void>(this.BASE_URL + '/' + idCaracteristique);
  }
}
